module.exports = __webpack_public_path__ + "img/b46bfb4.jpg";